import { gql } from "@apollo/client";

export const logUserActivityMutation = gql`
  mutation logUserActivity($input: [LogUserActivityInput!]) {
    platform {
      logUserActivity(input: $input)
    }
  }
`;
